// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/ConfigurationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_ConfigurationChooser{
  leads_configurations {
    id
    name
    organization {
      id
      _id
      name
      level
      parent_company {
        id
        name
        level
      }
      parent {
        id
        name
        level
      }
    }
  }
}

`